import { Component, OnInit, Input, ComponentFactoryResolver, Injector, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { TetherDialog } from '../../../common-module/modules/tether-dialog/tether-dialog';
import { NotificationService } from '../../../../services/notification.service';
import { EventLicense } from '../../../../models/event-license';

@Component({
  selector: 'app-event-license-block',
  templateUrl: './event-license-block.component.html',
  styleUrls: ['./event-license-block.component.scss']
})
export class EventLicenseBlockComponent implements OnInit {

  @Output() changeEventLicenseBlockEvent : EventEmitter<EventLicense> = new EventEmitter<EventLicense>();
  @Input() contextMenuData: {action: string, label: string, icon?: string, params?: any, group?: any }[];
  @Input() eventLicense: EventLicense = new EventLicense();

  constructor(private resolver: ComponentFactoryResolver,
    private injector: Injector,
    public tetherService: TetherDialog,
    private changeDetector: ChangeDetectorRef,
    private notificationService: NotificationService) { 
    }

  ngOnInit() {  
    if(!this.eventLicense.Localization) {
      var localization = {
        En: {
          Name: "",
          StaticText: ""
        },
        Tr: {
          Name: "",
          StaticText: ""
        }
      }
      this.eventLicense.setLocalization(localization);
      this.eventLicense.IsRequired = false;
    }
  }

  descriptionChangeHandler(event) {
    if (event.localization){
      this.eventLicense.Localization.StaticText = event.localization;
      this.changeEventLicenseBlockEvent.emit(this.eventLicense);
    }
  }
  
  inputChangeHandler(event) {
    if (event.localization){
      this.eventLicense.Localization.Name = event.localization;
      this.changeEventLicenseBlockEvent.emit(this.eventLicense);
    }
  }

  checkHandler(event){
    this.eventLicense.IsRequired = event;
    this.changeEventLicenseBlockEvent.emit(this.eventLicense);
  }

  isActiveCheckHandler(event) {
    this.eventLicense.IsActive = event;
    this.changeEventLicenseBlockEvent.emit(this.eventLicense);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/backstage-module/components/event-license-block/event-license-block.component.ts